<template>
  <Loader v-if="loading" />
  <div v-else class="content">
    <h1>New customer - Sneak peeks</h1>
    <SubscriptionsStatistics type="sneak_peek" />
  </div>
</template>

<script>
import Vue from 'vue'

import SubscriptionsStatistics from "@/components/statistics/SubscriptionsStatistics.vue"
export default {
  components: {
    SubscriptionsStatistics
  }
}
</script>
